import React, {Component} from 'react'

import MainLayout from "../components/main-layout/MainLayout";

import {Redirect, Route, Switch} from 'react-router-dom';
import CarModelPage from "../components/car-model-page/CarModelPage";

import {connect} from "react-redux";
import CalculatorPage from "./calculator-page/CalculatorPage";
import Payment from "../components/configurator/Payment";
import CustomerInfo from '../components/configurator/CustomerInfo';
import Thank from '../components/configurator/Thank';

let prefix = '';
class RootRoute extends Component {

    render(){
        let prefix = '';
        return <MainLayout>
              <Switch>
                  <Route path="/" exact component={CarModelPage} />
                  <Route path={prefix+"/calculator/:variantId/:isNew"} component={CalculatorPage}/>
                  <Route path={prefix+"/calculator/:variantId/:isNew/:carModelId/:color/:loanPercent/:tenure"} component={CalculatorPage}/>
                  <Route path={prefix+"/customer_info/:variantId/:isNew/:carModelId/:color/:loanPercent/:tenure/:msrp"} component={CustomerInfo} />
                  <Route path={prefix+"/thank"} component={Thank} />
                  <Route path={prefix+"/payment/:id"} component={Payment} />
                  <Route path="/car/:id" exact component={CarModelPage} />
              </Switch>
        </MainLayout>;
    }
}

const mapStateToProps = (state) => {
    return {
        context: state.context
    };
};
const mapDispatchToProps = (dispatch) => {
    return {
    };
};

const ConnectedRootRoute = connect(mapStateToProps, mapDispatchToProps)(RootRoute);

export default (props) =>
<React.Fragment>    
  <Switch>
    {/* <Route path={prefix="/login"} component={LoginPage}/> */}
    <Route component={ConnectedRootRoute}/>
  </Switch>
</React.Fragment>


//export default withRouter(connect(mapStateToProps, mapDispatchToProps)(RootRoute));


// WEBPACK FOOTER //
// ./src/containers/RootRoute.js